import React, { useEffect } from "react";
import "./accountFAQ.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserPlus,
  faKey,
  faEnvelope,
  faUserGear,
  faTrashAlt
} from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";


export default function AccountFAQ() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>SHOP.CO | Account FAQ - Help & Support</title>
        <meta
          name="description"
          content="Find answers to frequently asked questions about your SHOP.CO account, orders, payments, and more."
        />

        <link
          rel="canonical"
          href="https://shop-co-roan.vercel.app/FAQ/Account/"
        />
      </Helmet>
      <div className="account-faq-container">
        <header className="account-faq-header">
          <h1>Account Help</h1>
          <p>Here are answers to the most common questions about your account.</p>
        </header>

        <div className="account-faq-list">
          <div className="account-faq-item">
            <FontAwesomeIcon icon={faUserPlus} className="account-faq-icon" />
            <div>
              <h3>How do I create an account?</h3>
              <p>Click on the "Sign Up" button at the top right and fill in your basic details to register.</p>
            </div>
          </div>

          <div className="account-faq-item">
            <FontAwesomeIcon icon={faKey} className="account-faq-icon" />
            <div>
              <h3>I forgot my password. What should I do?</h3>
              <p>Click on “Forgot Password” at login and follow the instructions to reset it via your email.</p>
            </div>
          </div>

          <div className="account-faq-item">
            <FontAwesomeIcon icon={faEnvelope} className="account-faq-icon" />
            <div>
              <h3>Can I change my email address?</h3>
              <p>Yes, go to “Account Settings” and update your email under personal info.</p>
            </div>
          </div>

          <div className="account-faq-item">
            <FontAwesomeIcon icon={faUserGear} className="account-faq-icon" />
            <div>
              <h3>How do I update my profile?</h3>
              <p>Visit your account page and click on “Edit Profile” to update your details.</p>
            </div>
          </div>

          <div className="account-faq-item">
            <FontAwesomeIcon icon={faTrashAlt} className="account-faq-icon" />
            <div>
              <h3>How can I delete my account?</h3>
              <p>Contact our support team through the help center to permanently delete your account.</p>
            </div>
          </div>
        </div>
      </div>

    </>
  );
}
